import { BillingBalanceEffects } from './billing-balance.effects';
import { BillingPaymentInfoEffects } from './billing-payment-info.effects';
import { BillingTransactionsEffects } from './billing-transactions.effects';
import { CustomerAccountEffects } from './customer-account.effects';
import { CallDetailsEffects } from './call-details.effects';
import { PromiseOfPaymentEffects } from './promise-of-payment.effects';
import { PaymentDataEffects } from './payment.effects';
import { CategoryDetailsEffects } from './category-details.effects';
import { OdbCategoryDetailsEffects } from './odb-category-details.effects';
import { AppInitializationEffects } from './app-initialization.effects';
import { BillingCoverEffects } from './billing-cover.effects';
import { DeferralEffects } from './deferral.effects';
import { OdbUsageLevel4Effects } from './odb-usage-level-4.effects';
import { PdfDownloadEffects } from './pdf-download.effects';
import { BillingAggregatorEffects } from './billing-aggregator.effects';
import { ExtraCostEffects } from './extra-cost.effects';
import { BillingTransactionsReferencesEffects } from './billing-transactions-references.effects';

export const effects = [
  BillingTransactionsEffects,
  CustomerAccountEffects,
  BillingBalanceEffects,
  BillingPaymentInfoEffects,
  CallDetailsEffects,
  PromiseOfPaymentEffects,
  PaymentDataEffects,
  CategoryDetailsEffects,
  OdbCategoryDetailsEffects,
  AppInitializationEffects,
  BillingCoverEffects,
  DeferralEffects,
  OdbUsageLevel4Effects,
  PdfDownloadEffects,
  BillingAggregatorEffects,
  ExtraCostEffects,
  BillingTransactionsReferencesEffects,
];
